import React, { memo } from 'react';

import classNames from 'classnames';

import cls from './NotificationBody.module.css';
import { useNotificationBody } from './useNotificationBody';
import { NotificationItem } from '../NotificationItem/NotificationItem';
import { ModalSystemContent } from '../types/types';

interface NotificationBodyProps {
    classes?: string;
    onOpenModalSystem: (data: ModalSystemContent) => void;
    onClose: () => void;
    needFetch: boolean;
}

export const NotificationBody = memo(
    ({ classes, onOpenModalSystem, onClose, needFetch }: NotificationBodyProps) => {
        const { containerRef, notificationsIds, lastElementRef, isLastPage } =
            useNotificationBody();

        return (
            <div className={classNames(cls.NotificationBody, [classes])} ref={containerRef}>
                {notificationsIds.map((notificationId) => (
                    <NotificationItem
                        onClose={onClose}
                        key={notificationId}
                        id={notificationId}
                        onOpenModalSystem={onOpenModalSystem}
                    />
                ))}
                {!isLastPage && !needFetch && !!notificationsIds.length && (
                    <div className={cls.LoadMoreTrigger} ref={lastElementRef} />
                )}
            </div>
        );
    }
);
